export default __webpack_public_path__ + "static/media/approval-tick.8e7ac268.svg";